(() => {
  if (window.techableFacetControlsLoaded) return;
  window.techableFacetControlsLoaded = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.close_csrt')) {
      document.querySelectorAll('details.mobile-facets__disclosure').forEach((node) => {
        node.classList.remove('menu-opening');
        node.removeAttribute('open');
        node.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('details.facets__details.facets__accordion.js-filter').forEach((node) => {
        node.classList.remove('open');
        node.removeAttribute('open');
        node.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('drawer-open', 'overflow-hidden-tablet', 'open-drawer-filter-drawer');
    }
    const close = event.target.closest('.icon-close-button');
    if (close) {
      document.querySelectorAll('.filter-category').forEach((node) => node.classList.remove('open-popup'));
      const details = close.closest('details');
      if (details) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    }
    if (event.target.closest('.details-wrapper')) {
      document.querySelectorAll('.filter-category').forEach((node) => node.classList.add('open-popup'));
    }
    if (event.target.closest('.mobile_close')) {
      document.querySelectorAll('details.open').forEach((node) => {
        node.classList.remove('open');
        node.removeAttribute('open');
      });
    }
  });
})();
